
import { TableColumn } from '@/models/TableColumn'
import { sortBy } from 'lodash'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/Pagination.vue'

@Component({ 
  components:{
    Pagination
  }
})
export default class PaginatedTable extends Vue {
  @Prop({ default: '' })
  emptyMsg!: string;

  @Prop()
  columns!: TableColumn[];

  @Prop({ default: () => ([]) })
  data!: { [key: string]: string | { value: string; sortValue: string}}[];

  selectedAll = false;

  getSelectedAll() { 
    this.selectedAll = this.selected.length === this.data.length;
  }

  sortedData: { [key: string]: string | { value: string; sortValue: string}}[] = [];

  selected: number[] = [];

  toggleAll() {     
    if (!this.selectedAll){ 
      this.selected = [];
      for (let i = 0; i < this.data.length; i++) {
        this.selected.push(i);
      }
    }else{ 
      this.selected = [];
    }
    this.$forceUpdate();
    this.getSelectedAll();
  }

  onSelect() {
    setTimeout(()=>{
      this.getSelectedAll();
    }, 25);
  }

  @Watch('sortKey')
  @Watch('sortDirAsc')
  @Watch('data')
  sortData() {
    this.sortedData = this.data.map((r, index) => (Object.assign({
      index
    }, r)))

    if (!this.data.length || !this.sortKey) {
      this.$forceUpdate()
      return
    }

    this.sortedData = sortBy(this.sortedData, (row: any) => {
      let sortText = ''

      if (this.columns.find(c => c.key === this.sortKey)?.type === 'number'){ 
        if (typeof row[this.sortKey as string] === 'string'){
          return parseInt(row[this.sortKey as string])
        }else if (typeof row[this.sortKey as string] === 'number'){
          return row[this.sortKey as string];
        }
      }

      if (typeof row[this.sortKey as string] === 'object') {
        sortText = (row[this.sortKey as string] as { value: string; sortValue: string}).sortValue
      }

      if (!sortText && typeof row[this.sortKey as string] === 'string') {
        sortText = row[this.sortKey as string] as string
      }
      return sortText
    })

    if (!this.sortDirAsc) {
      this.sortedData = this.sortedData.reverse()
    }

    this.$forceUpdate()
  }

  mounted() {
    this.sortData()
  }

  sortKey = this.columns.find(h => h.selected)?.key || null
  sortDirAsc = !this.columns.find(h => h.selected)?.descDir || false

  onHeadingClick (heading: TableColumn)  {
    (this.$refs.pagination as Pagination).page = 0;

    if (!heading.sortable) {
      return
    }

    if (this.sortKey === heading.key) {
      this.sortDirAsc = !this.sortDirAsc
    } else {
      this.sortKey = heading.key
      this.sortDirAsc = true
    }
  }
}
